import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, gridConfig } from '@tvg/fuse-design';
import { NameProps } from './NameProps';

const Container = styled(TypographyElement)`
  margin-bottom: var(--spacing-space16);
  order: 1;

  @media (min-width: ${gridConfig.m.minWidth}) {
    order: 0;
  }
`;

const Brand = styled.span`
  display: block;
  font-weight: normal;
`;

const Title = styled.span``;

function Name({ brand, name }: NameProps) {
  return (
    <Container tag="h1" size="4">
      {brand && <Brand dangerouslySetInnerHTML={{ __html: brand }} data-testid="product_brand" />}
      <Title dangerouslySetInnerHTML={{ __html: name }} data-testid="product_title" />
    </Container>
  );
}

export default Name;
